<svg
    width="233"
    height="250"
    viewBox="0 0 233 250"
    xmlns="http://www.w3.org/2000/svg">
    <svg:path
        class="outer-roof"
        d="M0 90 L114 158 L187 114 L73 47 L0 90 Z" />

    <!-- Roof -->
    <svg:path
        d="M8.13 89.76 L113.56 152.27 L178.37 113.73 L72.91 51.23 L8.13 89.76 Z"
        [attr.fill]="'var(--roof-bg)'" />

    <g
        [x]="90"
        [y]="5"
        app-roof-vent></g>

</svg>